import { useEffect } from 'react';
import { useUnsavedChangesContext } from '../componentes/fichapaciente/UnsavedChangesGuard';

/**
 * Hook simplificado para componentes das tabs registrarem mudanças não salvas
 * @param {boolean} hasUnsavedChanges - Se há mudanças não salvas (edicao === false)
 * @param {string} tabKey - Identificador único da tab
 */
export const useTabProtection = (hasUnsavedChanges, tabKey) => {
  const { registerUnsavedTab, unregisterUnsavedTab } = useUnsavedChangesContext();

  useEffect(() => {
    if (hasUnsavedChanges) {
      registerUnsavedTab(tabKey);
    } else {
      unregisterUnsavedTab(tabKey);
    }
    
    // Cleanup quando componente desmonta
    return () => {
      unregisterUnsavedTab(tabKey);
    };
  }, [hasUnsavedChanges, registerUnsavedTab, unregisterUnsavedTab, tabKey]);
};